// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"_18WpN","item":"_3suVO","open":"_3DOEo","activator":"_1RvRk","heading":"_2o58H","title":"_1IpQ_","openIndicator":"_3-tUc","collapsibleContentWrapper":"_3r6FM"};